import React from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser } from "./useCurrentUser";

export function usePermissions() {
  const {
    permissions: currentUserPermissions,
    loading,
    hasPermission,
  } = useCurrentUser();
  const permissions = new Set<string>(currentUserPermissions.map((p) => p.id));

  // used for root directory
  let defaultPath = "/no-access";
  if (hasPermission("migrations.manage")) {
    defaultPath = "/migrations";
  } else if (hasPermission("migrations_runs.manage")) {
    defaultPath = "/migration-runs";
  } else if (hasPermission("agents.manage")) {
    defaultPath = "/agents";
  } else if (hasPermission("users.manage")) {
    defaultPath = "/users";
  }

  // Gates a route/element behind a permission, navigating the user to the
  // 404 page when they lack it.
  function permissionGate(
    permission: string,
    element: React.ReactElement,
  ): React.ReactElement {
    return hasPermission(permission) ? element : <Navigate to="/404" replace />;
  }

  return { permissions, loading, hasPermission, permissionGate, defaultPath };
}
